const current = {
  backgroundColor: ({ theme }) => theme.colors.laxrose,
  borderColor: ({ theme }) => theme.colors.cherryCobbler,
  borderRadius: ({ theme }) => theme.br.normal,
}

export default current
